import { type ErrorMessage, type Upsertable } from '../../components/form/errors'
import { ToastType } from '../../components/toasts'
import { toasts } from '../../components/toasts/toasts'
import { $t } from '@repo/i18n'
import { AuthErrorCodes } from 'firebase/auth'

export function handleFirebaseErrors(
	errors: Upsertable<ErrorMessage>,
): (reason: any) => void | PromiseLike<void> {
	return (e) => {
		const { code, message } = e
		switch (code) {
			case AuthErrorCodes.POPUP_CLOSED_BY_USER:
			case 'auth/cancelled-popup-request':
				break
			case AuthErrorCodes.INVALID_EMAIL:
			case AuthErrorCodes.USER_DISABLED:
			case AuthErrorCodes.USER_DELETED:
				if (errors) errors.upsert('email', { text: $t('form.emailNotFound') })
				break
			case AuthErrorCodes.INVALID_PASSWORD:
				if (errors) errors.upsert('password', { text: $t('form.invalidPassword') })
				break
			case AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER:
				toasts.add({
					title: $t('error.title'),
					text: $t('error.tooManyAttempts'),
					type: ToastType.error,
				})
				break
			default:
				// TODO: send to Sentry / GCP Logging
				console.error(code, message)
				toasts.add({
					title: $t('error.title'),
					text: $t('error.general'),
					type: ToastType.error,
				})
		}
	}
}
